import { useIntl } from "react-intl";

function RoleDataInfo(props) {
    const intl = useIntl();

    const getRoleArray = [
        { id: 0, title: ""},
        { id: 1, title: intl.formatMessage({ id: "role_administrador" }) },
        { id: 2, title: intl.formatMessage({ id: "role_Funcionario" }) },
        { id: 3, title: intl.formatMessage({ id: "role_utilizador" }) },
        { id: 4, title: intl.formatMessage({ id: "professeur" }) },
        { id: 5, title: intl.formatMessage({ id: "user_portier" }) },       
        { id: 10, title: intl.formatMessage({ id: "etudiant_" }) },
        { id: 20, title: intl.formatMessage({ id: "role_candidat" }) },


        { id: 101, title: intl.formatMessage({ id: "role_super_user" }) }
       
    ];

return getRoleArray;
}

export { RoleDataInfo as default } // no semi-colon